export enum GamesFilterType {
    Genres = "genres",
    Manufacturers = "manufacturers",
    Reels = "reels",
    Lines = "lines",
}
